<template lang="pug">
.table-wrapper(:class="{'filters-opened': filtersBlockDisplayed}")
    .table
        .table-header
            .header-row
                .cell(v-for='col in columns', v-show='col.show', :class='[col.cellWidth, col.textAlign, col.cellClass, col.sort ? "pointerCursor": "defaultCursor"]', @click='col.sort ? sortCol(col.key): true')
                    CellContent(:data='col.fullName')
                    .ordering(v-show='col.sort') &nbsp;{{ sort[col.key] ? (sort[col.key] == "asc" ? "&#8593;" : "&#8595;") : "&#8211;" }}
        .table-body-wrapper(ref='table-wrapper')
            spinner.l-flex-row--center.l-align-center(v-if="isLoading || isLoadingSharing" width="200" height="200")
            NoData(v-if="(!isLoading && !isLoadingSharing) && !mainData.length", :messages='config.errorMsg.noDataParent')
            .table-body(v-if='!isLoading && mainData.length')
                template(v-for='row in mainData')
                    .body-row(:class='{ opened: opened.includes(row.id), selected: row.id === selectedParentId, notClickable: disabledRowIds.includes(row.id) }', v-on='rowClickFunc === undefined ? {} : { click: () => rowClickHook(row.id) }')
                        .cell(v-if='col.show', v-for='col in columns', :class='[col.cellWidth, col.textAlign, col.cellClass]')
                            component(:is='col.component', :data='row[col.key]', :type='col.key', :fullData='row', @clickOnCell='loadChildData(row.id)')

                    transition(name='slide-fade')
                        .children-table-wrapper(v-if='opened.includes(row.id)')
                            .children-table
                                .children-table-header.custom-header
                                    .header-row
                                        .cell(v-for='childCol in childColumns', :class='[childCol.cellWidth, childCol.textAlign]')
                                            CellContent(:data='childCol.fullName')
                                            .ordering(v-show='childCol.sort') &nbsp;{{ sortChild[childCol.key] ? (sortChild[childCol.key] == "asc" ? "&#8593;" : "&#8595;") : "&#8211;" }}
                                .children-table-body-wrapper
                                    IsLoading(v-if='isLoadingSubTable && isLoadingItemId === row.id', :columns='childColumns', :parentId='row.id')

                                    //- in re-wam, do not display children error message but remove children array
                                    //-NoData(
                                        v-if='!isLoadingSubTable && (!children[row.id] || !children[row.id].length)',
                                        :messages='config.errorMsg.noDataChild'
                                    //-)

                                    .table-body(v-if='(!isLoadingSubTable || !(isLoadingItemId === row.id)) && children[row.id] && children[row.id].length')
                                        template(v-for='childRow in children[row.id]')
                                            .body-row(:class='{ selected: row.id === selectedChildId }')
                                                .cell(v-for='childCol in childColumns', :class='[childCol.cellWidth, childCol.textAlign]')
                                                    component(
                                                        :is='childCol.component',
                                                        :data='childRow[childCol.key]',
                                                        :type='childCol.key',
                                                        :fullData='childRow',
                                                        :parentId='row.id'
                                                    )

    Pagination(
        :currentPage='currentPage',
        :totalPages='pageCount',
        :visiblePages='visiblePages',
        :itemsPerPageList="itemsPerPageList",
        @loadPage='pageHandler',
        @itemsPerPage='itemsPerPage'
    )
</template>

<script>
import IsLoading from './Is-Loading'
import NoData from './No-Data'
import CellContent from './Cell-Content.vue'
import Pagination from './Pagination'
import { mapState } from 'vuex'

class Column {
    constructor(key, fullName, cellWidth, textAlign, sort, show, filter, component, cellClass) {
        this.key = key
        ;(this.fullName = fullName), (this.cellWidth = cellWidth)
        this.textAlign = textAlign
        this.cellClass = cellClass
        this.show = show != undefined ? show : true
        this.sort = sort != undefined ? sort : true
        this.filter = filter != undefined ? filter : true
        this.component = component != undefined ? component : CellContent
    }
}

export default {
    components: {
        IsLoading,
        NoData,
        CellContent,
        Pagination
    },
    /* eslint-disable */
    props: {
        config: { type: Object },
        loadMain: { type: Function },
        loadChild: { type: Function },
        opened: { type: Array },
        mainData: { type: Array },
        children: { type: Object },
        totalItems: { type: Number },
        rowClickFunc: { type: Function },
        sortChildFunc: { type: Function },
        defaultCurrentPage: { type: Number },
        visiblePages: { type: Number },
        itemsPerPageList: { type: Array },
        pageSize: { type: Number, default: 10 },
        selectedParentId: { type: [Number, String] },
        selectedChildId: { type: [Number, String] },
        disabledRowIds: { type: Array },
        filtersBlockDisplayed: { type: Boolean }
    },
    /* eslint-enable */
    data() {
        return {
            isLoading: false,
            isLoadingSubTable: false,
            isLoadingItemId: null,
            currentPage: this.defaultCurrentPage,
            pageCount: 0,
            columns: [],
            childColumns: [],
            sort: {}, //all sorts
            currentSort: {}, //actual sort
            sortChild: {},
            currentPageSize: null
        }
    },
    computed: {
        ...mapState('ui/settings', {
            isLoadingSharing: state => state.sharing.isLoading
        })
    },
    watch: {
        defaultCurrentPage: function(newPage) {
            if (newPage !== this.currentPage) {
                this.currentPage = newPage
            }
        },
        totalItems: function(newTotal) {
            const { currentPageSize } = this
            this.pageCount = Math.ceil(newTotal / currentPageSize)
        }
    },
    mounted() {
        const { columns, childColumns, totalItems } = this
        this.currentPageSize = this.pageSize
        this.pageCount = Math.ceil(totalItems / this.currentPageSize)
        if (this.defaultSort) this.currentSort = this.defaultSort
        const initSort = this.config.mainDataRow ? this.config.mainDataRow.find(c => c.sort === true) : null
        for (const c in this.config.mainDataRow) {
            const col = this.config.mainDataRow[c]
            columns.push(new Column(col.key, col.fullName, col.cellWidth, col.textAlign, col.sort, col.show, col.filter, col.component, col.cellClass))
            this.sort[col.key] = initSort && initSort.key === col.key ? initSort.sortOrder : null
        }
        const initSortChild = this.config.childDataRow ? this.config.childDataRow.find(c => c.sort === true) : null
        for (const c in this.config.childDataRow) {
            const col = this.config.childDataRow[c]
            childColumns.push(new Column(col.key, col.fullName, col.cellWidth, col.textAlign, col.sort, col.show, col.filter, col.component, col.cellClass))
            this.sortChild[col.key] = initSortChild && initSortChild.key === col.key ? initSortChild.sortOrder : null
        }
    },
    methods: {
        // Func which check condition then call the parent func
        async rowClickHook(rowId) {
            await this.rowClickFunc(rowId)
        },
        // Change the number of item per page, then call the main load func
        async itemsPerPage(value) {
            this.currentPageSize = value
            this.pageCount = Math.ceil(this.totalItems / value)
            if (this.currentPage > this.pageCount) {
                this.currentPage = 1
            }
            const { currentPage, currentPageSize, currentSort } = this
            await this.loadMainData({ currentPage, currentPageSize }, currentSort)
        },
        // When a new page is selected, call the main data load func
        async pageHandler(pageNumber) {
            this.currentPage = pageNumber
            const { currentPage, currentPageSize, currentSort } = this
            await this.loadMainData({ currentPage, currentPageSize }, currentSort)
        },
        // Call sort func on main data.
        async sortCol(colKey) {
            const { currentPage, currentPageSize } = this
            for (const itColKey in this.sort) {
                if (itColKey !== colKey) this.sort[itColKey] = null
            }
            this.sort[colKey] == null || this.sort[colKey] == 'asc' ? (this.sort[colKey] = 'desc') : (this.sort[colKey] = 'asc')
            this.currentSort = { key: colKey, order: this.sort[colKey] }
            await this.loadMainData({ currentPage, currentPageSize }, { ...this.currentSort })
        },
        // Call sort func on child data.
        /* async sortChildCol(col) {
            const { sortChild, sortChildFunc } = this
            this.sortChild[col] == null || sortChild[col] == 'asc' ? (sortChild[col] = 'desc') : (sortChild[col] = 'asc')
            await sortChildFunc(col, sort[col])
        }, */
        // Call func to load main set of data. The parent is responsible of change the data accordingly
        async loadMainData(pagination, sorting) {
            this.isLoading = true
            await this.loadMain(pagination, sorting)
            this.isLoading = false
            this.pageCount = Math.ceil(this.totalItems / this.currentPageSize)
        },
        // Call func to load secondary set of data. The parent is responsible of change the data accordingly
        async loadChildData(id) {
            this.isLoadingSubTable = true
            this.isLoadingItemId = id
            await this.loadChild(id)
            this.isLoadingItemId = null
            this.isLoadingSubTable = false
        }
    }
}
</script>
